import { Injectable } from '@angular/core';
import { SessionService } from '../../../../../../../angular-services-v8/session.service';
import { AuthUserProfile } from '../../../../../../../models/tokenResponse';

@Injectable()
export class StoreService {

  constructor(private sessionService: SessionService) {}
  get accessToken(): string | null {
    return this.sessionService.access_token;
  }
  get jwt(): string | null {
    return this.sessionService.jwt;
  }
  get countryCode(): string | null {
    return  this.sessionService.userCountry;
  }
  get customerId(): number | null {
    const userProfile = this.sessionService.profile;
    return userProfile?.customerId ?? null;
  }
  get customerCode(): string | null {
    const userLegalEntity = this.sessionService.currentLegalEntityValue;
    return userLegalEntity?.legalEntityTypeCode ?? null;
  }
  get userLegalEntity(): string | null {
    return sessionStorage.getItem("user_legal_entity");
  }
  get userProfile(): AuthUserProfile | null {
    return this.sessionService.profile;
  }
  get language(): string | null {
    return sessionStorage.getItem("language");
  }
  public isUserLogged(): boolean {
    return this.sessionService.access_token !== null;
  }
}
